import { createContext, useEffect } from "react";
import { useSelector } from "react-redux";
import i18n from "@i18n";

const LanguageContext = createContext({
  preferredLanguage: "en",
});
function ProviderLanguage(props: any) {
  const preferredLanguage = useSelector((state: any) => state.preferredLanguage);

  useEffect(() => {
    const isRTL = preferredLanguage === "ar";
    props.isRTLCallback?.(isRTL);
    i18n.changeLanguage(preferredLanguage);
    globalThis.localStorage.setItem("preferredLanguage", preferredLanguage);
  }, [preferredLanguage]);

  return (
    <LanguageContext.Provider
      value={{
        preferredLanguage,
      }}
    >
      {props.children}
    </LanguageContext.Provider>
  );
}

export default ProviderLanguage;
